<form [formGroup]="inputFormGroup()">
  <div [formGroupName]="inputFormGroupName()">
    @switch (htmlType()) {
      @case ("checkbox") {
        <ng-container *ngTemplateOutlet="chkBoxInput"></ng-container>
      }
      @case ("text") {
        <ng-container *ngTemplateOutlet="textInput"></ng-container>
      }
      @case ("textarea") {
        <ng-container *ngTemplateOutlet="textAreaInput"></ng-container>
      }
      @case ("date") {
        <ng-container *ngTemplateOutlet="datePicker"></ng-container>
      }
      @case ("time") {
        <ng-container *ngTemplateOutlet="timePicker"> </ng-container>
      }
      @case ("datetime-local") {
        <ng-container *ngTemplateOutlet="dateTimePicker"></ng-container>
      }
      @default {
        UNKNOWN INPUT TYPE: {{ htmlType() }}
      }
    }
  </div>
</form>

<ng-template #chkBoxInput>
  <frm-check
    [readonly]="isReadOnly()"
    [formControl]="inputControl()"
    [label]="inputLabel()"
  ></frm-check>
</ng-template>

<ng-template #textInput>
  <frm-text
    [rows]="16"
    [label]="inputLabel()"
    [readonly]="isReadOnly()"
    [formControl]="inputControl()"
  ></frm-text>
</ng-template>

<ng-template #textAreaInput>
  <frm-text
    [label]="inputLabel()"
    [formControl]="inputControl()"
    [readonly]="isReadOnly()"
    [multiline]="true"
    [rows]="16"
  ></frm-text>
</ng-template>

<ng-template #datePicker>
  <frm-date-picker
    [label]="inputLabel()"
    [readonly]="isReadOnly()"
    format="dd.MM.yyyy"
    [formControl]="inputControl()"
  ></frm-date-picker>
</ng-template>

<ng-template #dateTimePicker>
  <frm-date-picker
    [label]="inputLabel()"
    [readonly]="isReadOnly()"
    format="dd.MM.yyyy"
    [formControl]="inputControl()"
  ></frm-date-picker>
</ng-template>

<ng-template #timePicker>
  <frm-time-picker
    [formControl]="inputControl()"
    [label]="inputLabel()"
    [readonly]="isReadOnly()"
    mode="timeSpan"
  ></frm-time-picker>
</ng-template>
